import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StorageLocationItemBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-storage-location-item',
  templateUrl: './storage-location-item.component.html',
  styleUrls: ['./storage-location-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StorageLocationItemComponent extends StorageLocationItemBaseComponent {}
